import React from 'react';
import PropTypes from 'prop-types';
import style from '../../../scss/components/form.module.scss';
import buttonStyle from '../../../scss/components/buttons/button.module.scss';

const EntityUrlText = ({ entity, path, buttonText }) => {
    if (!entity) {
        return null;
    }

    const slug = entity.slug ?? entity.username;
    const url = `${path}/${slug}`;

    return (
        <div className={style.formGroup}>
            <a
                href={url}
                target="_blank"
                rel="noreferrer"
                className={buttonStyle.basic}
            >
                {`Go to ${buttonText}`}
            </a>
        </div>
    );
};

export default EntityUrlText;

EntityUrlText.propTypes = {
    /**
     * Type of entity
     */
    entity: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
};
